import React from "react";
import * as yup from "yup";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import { Report } from "../../../shared";

const schema = yup.object({
  epaId: yup.string(),
  name: yup.string(),
  street: yup.string(),
  county: yup.string(),
  cesPct: yup.string(),
  city: yup.string(),
  excludeCities: yup.string(),
  zipCode: yup.string(),
  status: yup.string(),
  naics: yup.string(),
  exclude: yup.string(),
  expectedClosureFDate: yup.date(),
  // TODO: Research Formik and why this is giving the "expectedClosureTDate" a red "required" asterik while not actually being required
  // Potentially could set initialTouched: true, but this does not seem to be working
  expectedClosureTDate: yup.date() // .when('expectedClosureFDate', (expectedClosureFDate, schema) => ((expectedClosureFDate) && schema.min(expectedClosureFDate, "Issued To date must be later than the Issued From date."))),
});

function LqgClosureReport() {
  const location = useLocation();
  const params = queryString.parse(location.search);
  const searchOnInit = Object.keys(params).length > 0 ? true : false;
  const initialFormValues = {
    epaId: params?.epaId ? params.epaId : "",
    city: params?.city ? params.city : "",
    excludeCities: params?.excludeCities ? params.excludeCities : "",
    county: params?.county ? params.county : "",
    closureType: params?.closureType ? params.closureType : "",
    name: params?.name ? params.name : "",
    street: params?.street ? params.street : "",
    zipCode: params?.zipCode ? params.zipCode : "",
    expectedClosureFDate: params?.expectedClosureFDate ? params.expectedClosureFDate : "",
    expectedClosureTDate: params?.expectedClosureTDate ? params.expectedClosureTDate : "",
    dateClosedFDate: params?.dateClosedFDate ? params.dateClosedFDate : "",
    dateClosedTDate: params?.dateClosedTDate ? params.dateClosedTDate : "",
  };
  const backToUrl = "/reports";
  const pageTitle = "Notification of LQG Site Closure";
  const apiEndpoint = "/api/v1/hwts/search/lqgclosures";
  const BASE_API_URI = process.env.REACT_APP_B2C_POST_LOGOUT_URI;
  const defaultExportParams = {
    allColumns: true,
    processCellCallback: params => {
      const field = params.column.getColDef().field;
      return field === 'EPA_ID' ? `=HYPERLINK("${BASE_API_URI}/facility/${params.value}","${params.value}")` : params.value;
    }
  };

  const formConfig = [
    {
        name: "epaId",
        config: {
          col: "md",
          colWidth: "2",
          label: "ID Number",
          placeholder: "",
          type: "text",
        },
    },
    {
        name: "city",
        config: {
          col: "md",
          colWidth: "3",
          label: "City",
          placeholder: "",
          type: "text",
          advanced: false,
        },
    },
    {
      name: "excludeCities",
      config: {
        col: "md",
        colWidth: "5",
        label: 
          <>Cities to Exclude<i className={`ca-gov-icon-question-line ml-2`}/></>
          ,
        placeholder: "",
        type: "text",
        info: "To exclude multiple cities, enter a comma after each city. You may exclude a maximum of 100 cities.",
      },
    },    
    {
        name: "county",
        config: {
          label: "County",
          col: "md",
          validate: true,
          colWidth: "4",
          placeholder: "Select a County",
          errorMessage: "A county is required.",
          type: "select3",
          apiEndpoint: "api/v1/hwts/search/counties",
          hasApi: true,
          advanced: false,
        },
    },    
    {
        name: "closureType",
        config: {
          col: "md",
          colWidth: "3",
          label: "Closure Type",
          placeholder: "",
          type: "select3",
          data: [
            { label: "All", value: "all" },
            { label: "Central Accumulation Area (CAA)", value: "A" },
            { label: "Entire Facility (EF)", value: "F" },
          ],
        },
    },
    {
      name: "name",
      config: {
        col: "md",
        colWidth: "9",
        label: "Handler Name",
        placeholder: "",
        type: "text",
        advanced: true,
      },
    },
    {
      name: "street",
      config: {
        col: "md",
        colWidth: "4",
        label: "Street",
        placeholder: "",
        type: "text",
        advanced: true,
      },
    },
    {
      name: "zipCode",
      config: {
        label: "Zip Code",
        col: "md",
        colWidth: "2",
        placeholder: "",
        type: "text",
        advanced: true,
      },
    },
    {
      name: "expectedClosureFDate",
      config: {
        col: "md",
        colWidth: "2",
        label: "Expected Closure From",
        placeholder: "",
        type: "date",
        advanced: false,
      },
    },
    {
      name: "expectedClosureTDate",
      config: {
        col: "md",
        colWidth: "2",
        label: "Expected Closure To",
        placeholder: "",
        type: "date",
        advanced: false,
      },
    },
    {
        name: "dateClosedFDate",
        config: {
          col: "md",
          colWidth: "2",
          label: "Date Closed From",
          placeholder: "",
          type: "date",
          advanced: false,
        },
      },
      {
        name: "dateClosedTDate",
        config: {
          col: "md",
          colWidth: "2",
          label: "Date Closed To",
          placeholder: "",
          type: "date",
          advanced: false,
        },
      },    
  ];

  const customGridCells = [
    {
      columnName: "EPA_ID",
      cellRenderer: function (params) {
        if (params.value != null) {
          return (
            `<a href="/facility/${params.value}" target="_">` +
            params.value +
            "</a>"
          );
        }
      },
    },
  ];

  return (
    <Report
      breadcrumb={[
        { name: "HWTS Reports", url: "/reports", active: false },
        { name: "Handler Search", url: "", active: true },
      ]}
      backToUrl={backToUrl}
      pageTitle={pageTitle}
      initialFormValues={initialFormValues}
      schema={schema}
      formConfig={formConfig}
      apiEndpoint={apiEndpoint}
      customGridCells={customGridCells}
      searchOnInit={searchOnInit}
      defaultExportParams={defaultExportParams}
    />
  );
}

export default LqgClosureReport;
